import i18n from "i18n";
import { toast } from "react-toastify";

const DownloadFile = async (src) => {
  fetch(src).then((response) => {
    response
      .blob()
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "video.mp4";
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((e) => {
        toast.error(i18n.t("downloadFaild"), {
          autoClose: 2000,
        });
      });
  });
};

export default DownloadFile;
